var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogicOperators(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.19,16a8.4,8.4,0,0,0,1.23-2A7.61,7.61,0,0,0,18,11.62H15.14A4.77,4.77,0,0,1,14.9,13a5.77,5.77,0,0,1-.52,1.18l-2.27-2.31a7.31,7.31,0,0,0,2.13-1.8,3,3,0,0,0,.64-1.8,2.81,2.81,0,0,0-.56-1.74A3.67,3.67,0,0,0,12.81,5.4,5.66,5.66,0,0,0,10.67,5a5.19,5.19,0,0,0-2,.38A3.66,3.66,0,0,0,7.11,6.47,2.74,2.74,0,0,0,6.5,8.29,3.26,3.26,0,0,0,6.93,10a8.14,8.14,0,0,0,1.19,1.6A8.19,8.19,0,0,0,6,13.17a3.35,3.35,0,0,0-.84,2.31A3,3,0,0,0,6.48,18,5.91,5.91,0,0,0,10,19a7.53,7.53,0,0,0,4.17-1.29l1,1h3.61Zm-6.5-8.6a1.54,1.54,0,0,1,1-.3,1.53,1.53,0,0,1,1,.33,1.09,1.09,0,0,1,.39.83,1.79,1.79,0,0,1-.28,1,4.67,4.67,0,0,1-1.19,1.08,13.25,13.25,0,0,1-.94-1,1.54,1.54,0,0,1-.38-1A1,1,0,0,1,9.69,7.43Zm.64,9.16a2.53,2.53,0,0,1-1.72-.46,1.47,1.47,0,0,1-.49-1.08c0-.7.52-1.33,1.57-1.9L12.5,16A4.27,4.27,0,0,1,10.33,16.59Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogicOperators);
export default __webpack_public_path__ + "static/media/logic_operators.1cbb0482e1589b5cf37573b3c12703ec.svg";
export { ForwardRef as ReactComponent };